export const productCategories = {
  Concentrate: [
    'Cartridge',
    'Disposable',
    'Pods',
    'Live Resin',
    'Rosin',
    'Crystalline',
    'Sauce',
    'Shatter',
    'Distillate',
    'Crumble',
    'Sugar Leaf',
    'Ice Hash',
    'Dry Sift',
    'Nug Run',
    'Jar',
  ],
  Preroll: ['Pre Roll', 'Infused Pre Roll', 'Blunt Wrap'],
  Edible: [
    'Gummies',
    'Chocolates',
    'Capsules',
    'Candy',
    'Cookies',
    'Beverages',
    'Syrup',
    'Treats',
    'Mints & Gum',
    'Vegan',
    'Snacks',
    'Baked Goods',
    'Sugar Free',
    'Brownies',
    'Butter',
    'Oral Spray',
    'Gluten Free',
    'Nut Free',
    'Cooking Ingredients',
    'Condiments',
  ],
  Gear: [
    'Accessories',
    'Pull',
    'Rolling Papers',
    'Apparel',
    'Batteries',
    'Pipes',
    'Push Button',
    'Grinders',
    'Vaporizer',
    'Bongs',
    'Dab Rigs',
    'Hoodies',
    'Dab Tools',
    'Hats',
    'Torches',
    'Banger & Nails',
    'Storage',
  ],
  Drink: ['Drinks', 'Powder'],
  Tincture: ['Tincture', 'Gluten Free'],
  Wax: ['Budder', 'Rosin'],
  Topicals: ['Balms & Salves', 'Patches', 'Lotions', 'Bath', 'Bombs', 'Lubricants & Oils'],
  Indica: ['Infused Flower', 'Shake'],
  Hybrid: ['Infused Flower', 'Shake'],
  Sativa: ['Infused Flower', 'Shake'],
  Flower: ['Shake', 'Eighths', 'Ounce', 'Quarters', 'Infused Flower'],
  'Vape Pens': ['Cartridge', 'Disposable', 'Pods', 'Pull', 'Push Button', 'Batteries'],
};

export type productCategoriesT = typeof productCategories;
export type productCategoryT = keyof typeof productCategories;
